module.exports = __webpack_public_path__ + "static/linkedin-9ec494e9f35432c10a85053629241f96.png";